import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useCart } from '../../context/CartContext.jsx';
import Logo from '../ui/Logo.jsx';
import Icon from '../ui/Icon.jsx';
import UserMenu from './UserMenu.jsx';

const NAV_ITEMS = [
  { to: '/',           label: '首頁',     match: ['/'],         exact: true },
  { to: '/shop',       label: '商品一覽', match: ['/shop', '/product'] },
  { to: '/virtual',    label: '虛擬商品', match: ['/virtual'] },
  { to: '/gallery',    label: '主題圖鑑', match: ['/gallery'] },
  // 最新資訊（News）暫時隱藏——功能未做（見 TODOS.md）。頁面/路由保留，之後要做再加回。
  // { to: '/news',       label: '最新資訊', match: ['/news'] },
];

function Header() {
  const { pathname } = useLocation();
  const { totalCount } = useCart();
  const [menuOpen, setMenuOpen] = useState(false);
  const isActive = (item) => item.exact
    ? pathname === item.to
    : item.match.some(m => pathname === m || pathname.startsWith(m + '/'));

  useEffect(() => { setMenuOpen(false); }, [pathname]);

  useEffect(() => {
    if (!menuOpen) return;
    const onKey = (e) => { if (e.key === 'Escape') setMenuOpen(false); };
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [menuOpen]);

  return (
    <header className="topbar">
      <Link to="/" className="brand" aria-label="MICHIDART 首頁">
        <Logo height={36} tone="white" />
      </Link>
      <button
        type="button"
        className={`menu-toggle${menuOpen ? ' open' : ''}`}
        aria-label={menuOpen ? '關閉選單' : '開啟選單'}
        aria-expanded={menuOpen}
        onClick={() => setMenuOpen(o => !o)}
      >
        <span /><span /><span />
      </button>
      {menuOpen && <div className="nav-overlay" onClick={() => setMenuOpen(false)} />}
      <nav className={`nav-pill${menuOpen ? ' open' : ''}`}>
        {NAV_ITEMS.map(item => (
          <Link
            key={item.to}
            to={item.to}
            className={`nav-link${isActive(item) ? ' active' : ''}`}
          >
            {item.label}
          </Link>
        ))}
      </nav>
      <div className="nav-actions">
        <UserMenu />
        <Link className="icon-btn" to="/cart" aria-label="購物車">
          <Icon name="cart" size={26} />
          {totalCount > 0 && <span className="cart-badge">{totalCount}</span>}
        </Link>
      </div>
    </header>
  );
}

export default Header;
